import { jsxs, jsx, Fragment } from '@emotion/react/jsx-runtime';
import { css } from '@emotion/react';
import { useState, useEffect } from 'react';
import { SvgChevronDownSingle } from '../__generated__/icons/SvgChevronDownSingle.js';
import { mergeThemes } from '../utils/themes.js';
import { AccordionRowNoJS } from './AccordionRowNoJS.js';
import { accordionRow, button, chevronIconUp, chevronIconDown, toggleIconWithLabel, labelText, toggle, toggleLabel, expandedBody, collapsedBody } from './styles.js';
import { transformProviderTheme, themeAccordion } from './theme.js';
import { visuallyHidden as visuallyHidden$1 } from '../../foundations/accessibility/visually-hidden.js';
const visuallyHidden = css `
	${visuallyHidden$1}
`;
const AccordionRow = ({ label, hideToggleLabel = false, children, cssOverrides, onClick = () => void 0, theme }) => {
    const [expanded, setExpanded] = useState(false);
    const collapse = () => setExpanded(false);
    const expand = () => setExpanded(true);
    const [isBrowser, setIsBrowser] = useState(false);
    const mergedTheme = (providerTheme) => mergeThemes(themeAccordion, theme, providerTheme, transformProviderTheme);
    function handleClick(event) {
        if (expanded) {
            collapse();
        }
        else {
            expand();
        }
        onClick(event);
    }
    useEffect(() => {
        setIsBrowser(true);
    }, []);
    if (isBrowser) {
        return /* @__PURE__ */ jsxs("div", {
            css: (providerTheme) => [
                accordionRow(mergedTheme(providerTheme.accordion)),
                cssOverrides
            ],
            children: [
                /* @__PURE__ */ jsxs("button", {
                    type: "button",
                    "aria-expanded": expanded,
                    onClick: handleClick,
                    css: (providerTheme) => [
                        button(mergedTheme(providerTheme.accordion)),
                        expanded ? chevronIconUp : chevronIconDown,
                        !hideToggleLabel ? toggleIconWithLabel : ""
                    ],
                    children: [
                        /* @__PURE__ */ jsx("strong", { css: labelText, children: label }),
                        /* @__PURE__ */ jsxs("div", { css: toggle, children: [
                                hideToggleLabel ? /* @__PURE__ */ jsx("span", { css: visuallyHidden, children: expanded ? "Hide" : "Show more" }) : /* @__PURE__ */ jsx("span", {
                                    css: (providerTheme) => toggleLabel(mergedTheme(providerTheme.accordion)),
                                    children: expanded ? "Hide" : /* @__PURE__ */ jsxs(Fragment, { children: [
                                            "Show",
                                            /* @__PURE__ */ jsx("span", { css: visuallyHidden, children: " more" })
                                        ] })
                                }),
                                /* @__PURE__ */ jsx(SvgChevronDownSingle, { theme: { fill: theme?.iconFill } })
                            ] })
                    ]
                }),
                /* @__PURE__ */ jsx("div", {
                    css: (providerTheme) => expanded ? expandedBody(mergedTheme(providerTheme.accordion)) : collapsedBody,
                    children: /* @__PURE__ */ jsx("div", { hidden: !expanded, children })
                })
            ]
        });
    }
    return /* @__PURE__ */ jsx(AccordionRowNoJS, {
        label,
        hideToggleLabel,
        cssOverrides,
        children
    });
};
export { AccordionRow };
